import React from "react"

import { cn } from "../../../utils/cn.ts"

interface PortalPageContainerProps {
  children: React.ReactNode
  className?: string
  /** Calendar's own requirement: use the *available* main-content width
   * (sidebar-adjacent, 24-32px side padding) rather than the ~1360px
   * centered column every other portal screen uses. Keep this opt-in — a
   * narrow, centered column is the right call for a form-shaped page like
   * Settings, and widening those was never asked for. */
  fullWidth?: boolean
}

/** The one page-width rule every portal screen shares: ~1360px max, centered
 * within whatever width remains beside the sidebar (never the full
 * viewport), 24px padding up to 32px on desktop, 16px on mobile. No portal
 * page should nest a second width-constraining container inside this one. */
export function PortalPageContainer({
  children,
  className,
  fullWidth
}: PortalPageContainerProps) {
  return (
    <div
      className={cn(
        "w-full px-4 py-6 sm:px-6 sm:py-7 lg:px-8 lg:py-8",
        fullWidth ? "flex flex-col" : "mx-auto max-w-[1360px]",
        className
      )}
    >
      {children}
    </div>
  )
}
